export enum ReportType {
  BY_USER,
  BY_USER_DEP,
  BY_GROUP,
  BY_DAY_OFF,
  BY_VECTOR,
  BY_VECTOR_ALL_GROUP,
  BY_KARMA,
  BY_VACATION,
  SHIFT,
  BY_PROFILE,
  BY_VACATION_GROUP,
  BY_DAY_OFF_GROUP
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/models/report-type.model.ts